<template lang="html">
  <div class="amap-wrapper">
    <el-amap :vid="'amap-vue'">
    </el-amap>
  </div>

</template>

<script>
export default {

}
</script>

<style lang="css">
.amap-wrapper {
  width: 500px;
  height: 500px;
}
</style>



// WEBPACK FOOTER //
// Map.vue?1f2427ca